import MobileObjectControllers from './MobileObjectControllers'

export default MobileObjectControllers;